import api from "../api";
import { ETipoQuestao } from "../../Enum/Enum";


export async function getRespostasQuestao(IDQuestao_Secao) {
    try {
        const response = await api.get(`/chkquestaoresposta/questaosecao/${IDQuestao_Secao}`);
        const formatarDataHora = (valor) => {
            if (!valor) return null;
            const data = new Date(valor);
            if (Number.isNaN(data.getTime())) return null;
            return data.toLocaleString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false
            });
        };
        const retorno = response.data.map(item => ({
            ...item,
            dataPrimeiraResposta: formatarDataHora(item.dataPrimeiraResposta),
            dataPrimeiraRespostaRaw: item.dataPrimeiraResposta
                ? new Date(item.dataPrimeiraResposta)
                : null,
            dataUltimaResposta: formatarDataHora(item.dataUltimaResposta),
            dataUltimaRespostaRaw: item.dataUltimaResposta
                ? new Date(item.dataUltimaResposta)
                : null
        }));

        return retorno;
    } catch (error) {
        console.error('Falha ao buscar respostas da questão', error);
        return [];
    }
}

export function getTipoQuestao(tipo) {
    return ETipoQuestao[tipo];
}

export async function getObjetoQuestao(IDObjeto) {
    try {
        const response = api.get(`/chkobjeto/${IDObjeto}`).then((response) => response.data);
        return response;
    } catch (error) {
        console.error('Falha ao buscar o objeto', error);
        return null;
    }
}
